<template>
  <div class="code-manage">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right"
             @submit.native.prevent>
      <div class="self-adapting-condition">
        <el-form-item label="类别名称：">
          <el-input class="zwx-input" v-model="mainForm.codeTypeNameLike" placeholder="请输入"
                    @keyup.enter.native="search(1)" clearable />
        </el-form-item>
        <div class="condition-button-row">
          <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">
            查询
          </el-button>
        </div>
      </div>
    </el-form>

    <!-- 列表展示部分 -->
    <el-table class="zwx-table" height=" calc(100vh - 152px)" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="codeTypeCode" label="类别编码"
                       :width="$system.calWidth(dataList, 'codeTypeCode', '类别编码')" header-align="center"
                       align="center" />
      <el-table-column prop="codeTypeName" label="类别名称"
                       :width="$system.calWidth(dataList, 'codeTypeName', '类别名称')" header-align="left"
                       align="left" />
      <el-table-column prop="ifTree" label="树形" width="58" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.ifTree">
            <span class="status-color"></span>
            <span class="status-text">是</span>
          </div>
          <div v-else>
            <span class="status-color" style="background: #A09F9F"></span>
            <span class="status-text">否</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作"
                       :min-width="$system.calMinWidth({ wordNum: 4, arrowNum: 1, btnNum: 1 })" header-align="left"
                       align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="simpleCode(scope.row)">码表维护
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange" />
  </div>
</template>

<script>
export default {
  name: "CodeManage",
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      mainForm: {
        codeTypeNameLike: ""
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0
    };
  },
  created() {
  },
  mounted() {
    this.search(this.currentPage);
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage);
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage);
    },
    search(currentPage) {
      this.$emit("loading", true);
      this.currentPage = currentPage;
      let data = {
        currentPage: this.currentPage,
        codeTypeNameLike: this.mainForm.codeTypeNameLike
      };
      this.$system.get(this.api + "/systematic/getCodeTypeList-1", data, true, true, this.searchSuccess, this.error);
    },
    searchSuccess(data) {
      if (data.type === "00") {
        this.dataList = data.codeTypeList;
        this.total = data.codeTypeCount;
        this.pageSize = data.pageSize;
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
      }
      this.$emit("loading", false);
    },
    simpleCode(row) {
      this.$router.push({
        name: "SimpleCode",
        params: {
          codeTypeId: row.rid,
          codeTypeCode: row.codeTypeCode,
          codeTypeName: row.codeTypeName,
          codeTypeIfTree: row.ifTree
        }
      });
    },
    error() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
    }
  }
};
</script>

<style lang="less" scoped>
.status-color {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  background: #4bc940;
}

.status-text {
  display: inline-block;
  line-height: 28px;
  font-size: 14px;
  color: #0e161f;
  font-weight: 400;
  margin-left: 4px;
  vertical-align: middle;
}
</style>

<style lang="less"></style>
